import { MobileDeviceHeight } from "ui/src/hooks/constants";
export const useIsShortMobileDevice = (_deviceHeight = MobileDeviceHeight.iPhone12) => {
  return false;
};
